import AXIOS from '@/axios-instance';
import store from "@/store.js"

export default {

  uploadFileAsText(uuid, content) {
    return AXIOS.put("/bpmn/" + uuid,
      content
    );
  },
  saveReviewFile(uuid, content) {
    return AXIOS.put("/bpmn/release/" + uuid,
      content
    );
  },
  getAllFilesForProcessCharacteristic() {
    return AXIOS.get("/bpmn/characteristic")
  },
  checkTmpModel(uuid) {
    return AXIOS.get("/bpmn/release/" + uuid);
  },
  getProcessXml(uuid) {
    return AXIOS.get("/bpmn/" + uuid);
  },
  getReviewProcessXml(uuid, reviewId) {
    return AXIOS.get("/bpmn/release/" + uuid + "/review/" + reviewId);
  },
  shareTask(uuid, userId) {
    return AXIOS.post("/bpmn/" + uuid + "/shared-user", {
      userId: userId
    });
  },
  retrieveSharedUsers(uuid) {
    return AXIOS.get("/bpmn/" + uuid + "/shared-user");
  },
  removeSharedUser(uuid, userId) {
    return AXIOS.delete("/bpmn/" + uuid + "/shared-user/" + userId);
  },
  retrieveAllUsers() {
    return AXIOS.get("/user");
  },
  retrieveModelInformation(uuid) {
    return AXIOS.get("/bpmn/" + uuid + "/information");
  },
  setEditingMode(uuid, userId) {
    return AXIOS.post("/bpmn/" + uuid + "/editMode",
      {
        currentEditor: userId
      });
  },
  getElementsWithAttachments(uuid) {
    return AXIOS.get("/bpmn/" + uuid + "/attachments");
  },
  createContextBadge(element) {
    const badgeColor = '#' + store.state.clientColor;
    let targetComment = 'comments';
    let targetDocument = 'documents';
    let targetDescription = "description";
    let targetLinks = "mngmtLinks";
    let html = '';
    let badgeCount = 0;
    let attachmentCount = 0;
    if (element.hasComment) ++attachmentCount;
    if (element.hasDocument) ++attachmentCount;
    if (element.hasDescription) ++attachmentCount;
    if (element.hasMngmtLink) ++attachmentCount;
    if (attachmentCount > 0) html += '<div>';

    if (element.hasComment) {

      html += '<div style="border-radius: 5px; left: ' + (attachmentCount - badgeCount) * (-12) + 'px" onclick="' + targetComment + '" class="modeling-tooltip"><div class="svg-container"><svg width="22"' +
        ' height="22"' +
        ' viewBox="0 0' +
        ' 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<circle cx="11" cy="11" r="10" fill="' + badgeColor + '" stroke="white" stroke-width="1.2"/>\n' +
        '</svg></div>\n<i style="font-size: 12px; color: #fff;"' +
        ' class="material-icons pointer">forum</i><span class="modeling-tooltip-text">Kommentare</span></div>'
      badgeCount++;
    }
    if (element.hasDocument) {

      html += '<div style="border-radius: 5px; left: ' + (attachmentCount - badgeCount) * (-12) + 'px" onclick="' + targetDocument + '" class="modeling-tooltip"><div class="svg-container"><svg width="22"' +
        ' height="22"' +
        ' viewBox="0 0' +
        ' 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<circle cx="11" cy="11" r="10" fill="' + badgeColor + '" stroke="white" stroke-width="1.2"/>\n' +
        '</svg></div>\n<i style="font-size: 12px; color: #fff;"' +
        ' class="material-icons pointer">description</i><span class="modeling-tooltip-text">Dokumente</span></div>'
      badgeCount++;
    }
    if (element.hasDescription) {

      html += '<div style="border-radius: 5px;left: ' + (attachmentCount - badgeCount) * (-12) + 'px" onclick="' + targetDescription + '" class="modeling-tooltip"><div class="svg-container"><svg width="22"' +
        ' height="22"' +
        ' viewBox="0 0' +
        ' 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<circle cx="11" cy="11" r="10" fill="' + badgeColor + '" stroke="white" stroke-width="1.2"/>\n' +
        '</svg></div>\n<i style="font-size: 12px; color: #fff;"' +
        ' class="material-icons pointer">edit</i><span class="modeling-tooltip-text">Beschreibung</span></div>'
      badgeCount++;
    }
    if (element.hasMngmtLink) {

      html += '<div style="border-radius: 5px;left: ' + (attachmentCount - badgeCount) * (-12) + 'px" onclick="' + targetLinks + '" class="modeling-tooltip"><div class="svg-container"><svg width="22"' +
        ' height="22"' +
        ' viewBox="0 0' +
        ' 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<circle cx="11" cy="11" r="10" fill="' + badgeColor + '" stroke="white" stroke-width="1.2"/>\n' +
        '</svg></div>\n<i style="font-size: 12px; color: #fff;"' +
        ' class="material-icons pointer">link</i><span class="modeling-tooltip-text">Link</span></div>'
      badgeCount++;
    }
    if (attachmentCount > 0) html += '</div>'
    return {
      position: {
        top: 0,
        right: 0
      },
      html: $(html)
    }
  },
  createPxBadge(element) {
    const badgeColor = '#' + store.state.clientColor;
    let html = '';
    if (element.hasQuestion) {
      html += '<div style="border-radius: 5px; " class="modeling-tooltip"><div class="svg-container"><svg width="22"' +
        ' height="22"' +
        ' viewBox="0 0' +
        ' 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<circle cx="11" cy="11" r="10" fill="' + badgeColor + '" stroke="white" stroke-width="1.2"/>\n' +
        '</svg></div>\n<i style="font-size: 12px; font-weight: 700; color: #fff;"' +
        ' class="material-icons pointer">check</i><span class="modeling-tooltip-text">Fragen</span></div>'
    }
    return {
      position: {
        top: 0,
        right: 0
      },
      html: $(html)
    }
  },
  createNumberBadge(element, elemCount) {
    const badgeColor = '#' + store.state.clientColor;
    const badgeHtml = document.createElement('div');
    badgeHtml.contentEditable = true;
    badgeHtml.innerText = elemCount;
    badgeHtml.style.cssText = `
      background: #eee; 
      border: 1px solid #aaa; 
      border-radius: 3px; 
      font-size: 12px; 
      padding: 2px 5px; 
      position: absolute;
    `;
    return {
      position: {
        right: 5,
        bottom: 5
      },
      html: badgeHtml
    }
  },
  createEvaluationBadge(score) {
    const badgeColor = this.calculateEvaluationColor(score);
    let html = '';
    let numberNames = ['one', 'two'];
    let iconName = score;
    if (score < 3) {
      let num = Math.trunc(score);
      iconName = numberNames[num - 1];
    }

    html += '<div style="border-radius: 5px; " class="modeling-tooltip"><div class="svg-container"><svg width="22"' +
      ' height="22"' +
      ' viewBox="0 0' +
      ' 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
      '<circle cx="11" cy="11" r="10" fill="' + badgeColor + '" stroke="white" stroke-width="1.2"/>' +
      '</svg></div><span style="font-weight: 700; color: #fff; z-index: 99;"' +
      ' class="modeling-tooltip-score">' +
      score + '</span>' +
      '<span class="modeling-tooltip-text modeling-tooltip-text__left">Auswertung</span></div>'

    return {
      position: {
        bottom: 8,
        left: 0
      },
      html: $(html)
    }
  },
  calculateEvaluationColor(score) {
    if (score < 3) {
      return "#23B480";
    } else if (score < 5) {
      return "#ECB66C";
    } else {
      return "#ED484F";
    }
  },
  createTimestampForProcessModel(uuid) {
    return AXIOS.post("/px/evaluation/process/timestamp", uuid, {
      headers: { "Content-Type": "application/json" }
    });
  }
}